export default "__VITE_ASSET__IMPkJHvo__"